import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { StandardDialog } from '@roc/ui';
import { Document } from '@roc/feature-types';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { InsertDriveFile } from '@material-ui/icons';
import { LoanProcess } from '@roc/feature-utils';
import { Typography } from '@material-ui/core';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { LineItemUpload } from '@roc/feature-loan-details';
import { useStore } from '@roc/client-portal-shared/hooks';

interface Props {
  open?: boolean;
  onClose?: () => void;
  document: Document;
  expand: boolean;
}

export const CertificateOfGoodStandingDialog = observer(({ document, open, onClose, expand }: Props) => {

  const { documentStore } = useDocumentStore();
  const taskId = document?.taskId;
  const { cogsStore } = useStore();

  useEffect(() => {
    document.canUploadFile = true;
  }, []);

  useEffect(() => {
    if (open && taskId) {
      setCogsValue();
    }
  }, [open, taskId]);

  const setCogsValue = async () => {
    try {
      await cogsStore?.fetchIsCogsOnline(document?.loanId);
    } catch (err) {
    }
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          title={document?.taskName}
          open={open}
          handleClose={() => {
            documentStore.closeDocumentPreviewV2();
            documentStore.loanTodosStore.fetchTodos(document?.loanId, LoanProcess.UNDERWRITING);
            onClose();
          }}
          dialogLogo={< InsertDriveFile />}
          dialogContent={
            <>
              <LineItemUpload document={document} expand={expand} customTopContent={(
                <>
                  {!cogsStore?.isCogsLoading && cogsStore?.isCogsOnline ? <Typography variant="body1" gutterBottom>
                    Please upload a screenshot to show the entity is in good standing.
                  </Typography> : <Typography variant="body1" gutterBottom>
                    Please upload the Certificate of Good Standing.
                  </Typography>}
                </>
              )} />
            </>
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          title={document?.taskName}
          open={open}
          handleClose={() => {
            documentStore.closeDocumentPreviewV2();
            documentStore.loanTodosStore.fetchTodos(document?.loanId, LoanProcess.UNDERWRITING);
            onClose();
          }}
          maxWidth={"xl"}
          removeContentBox={true}
          dialogLogo={< InsertDriveFile />}
          dialogContent={
            <>
              <LineItemUpload document={document} expand={expand} />
            </>
          }
        />
      )}

    </>
  );
});

export default CertificateOfGoodStandingDialog;